import { LOCATION_CHANGE } from 'react-router-redux'
import { INITIAL_LOAD, trackAnalyticsEvent } from 'common/redux/root'
import { LOGIN, LOGOUT } from 'common/redux/auth'
import { selectAuthUser, selectUserCompany, selectUserType, selectIsMasquerade } from 'common/redux/selectors/auth'

import { createMiddleware, createMetaReducer } from 'redux-beacon'
import Segment from '@redux-beacon/segment'
import combineEvents from '@redux-beacon/combine-events'
import { trackPageView, identifyUser, trackEvent as trackSegmentEvent, reset } from '@redux-beacon/segment'
import * as Sentry from '@sentry/browser'

const segment = Segment()

export const activateSegment = sourceKeyId => {
  // tracking snippet from segment.com
  // eslint-disable-next-line no-console
  !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
  analytics.load(sourceKeyId);
  }}();
}

const commonEventsMap = {}

const userIdentity = identifyUser((_action, _prevState, nextState) => {
  let options = {traits: {}}
  const {user_hash} = selectAuthUser(nextState)
  const company = selectUserCompany(nextState)
  const userType = selectUserType(nextState)
  const isMasquerade = selectIsMasquerade(nextState)

  const { infoForSegment } = nextState.root

  if (user_hash) {
    options.userId = user_hash
  }

  if (company) {
    options.traits.company = company
  }

  if (userType) {
    options.traits.userType = userType
  }

  if (isMasquerade) {
    options.traits.isMasquerade = isMasquerade
  }

  options = {...options, ...infoForSegment}

  return options
})

const pageView = trackPageView((_action, _prevState, nextState) => {
  const _arguments = {}
  const { user_hash } = selectAuthUser(nextState)
  const options = {}

  if (user_hash) {
    options.userId = user_hash
  }

  _arguments['options'] = options

  return _arguments
})

// Common or global events here
commonEventsMap[LOCATION_CHANGE] = combineEvents(userIdentity, pageView)
commonEventsMap[LOGIN] = userIdentity
commonEventsMap[LOGOUT] = reset()
commonEventsMap[INITIAL_LOAD] = combineEvents(userIdentity, pageView)


export const createAnalyticsMiddleware = (eventsMap = {}, disableAutomaticPageEvents = false) => {
  const {enable_analytics} = window.OD.initialState
  if (!enable_analytics) {
    return createMiddleware({}, segment)
  }

  if (disableAutomaticPageEvents) {
    commonEventsMap[LOCATION_CHANGE] = userIdentity
    commonEventsMap[INITIAL_LOAD] = userIdentity
  }

  const combinedMap = {...commonEventsMap, ...eventsMap}
  return createMiddleware(combinedMap, segment)
}


export const createAnalyticsReducer = (eventsMap = {}, disableAutomaticPageEvents = false) => {
  const {enable_analytics} = window.OD.initialState
  if (!enable_analytics) {
    return createMetaReducer({}, segment)
  }

  if (disableAutomaticPageEvents) {
    commonEventsMap[LOCATION_CHANGE] = userIdentity
    commonEventsMap[INITIAL_LOAD] = userIdentity
  }

  const combinedMap = {...commonEventsMap, ...eventsMap}
  return createMetaReducer(combinedMap, segment)
}


const trackEventLegacy = () => (trackSegmentEvent((action) =>  {
  const {name, properties, options} = action.payload.metadata.analytics
  return {
    name,
    properties,
    options,
  }
}))

export const eventTrackerLegacy = trackEventLegacy()

export const segmentEventTracker = (eventName, properties={}, extraOptions={}, manualPageName='', callback=null) => {
  let trackEvent = new Promise(
    (resolve) => {
      if (window.analytics) {
        let usedOptions = extraOptions

        if (manualPageName) {
          const pageContext = {'context': {'page': {
            'path': '#' + manualPageName,
            'url': window.location.href + '#' + manualPageName
          }}}

          usedOptions = {...extraOptions, ...pageContext}
        }

        window.analytics.track(
          eventName,
          properties,
          usedOptions
        )
      }

      resolve()
    })

  if (typeof callback === 'function') {
    trackEvent.then(() => { callback() })
              .catch(err => {
                Sentry.captureException(new Error(err))
                setTimeout(callback, 200)
              })
  }
}

export const segmentManualPageTracker = (pageName, extra_properties={}, options={}) => {
  if (window.analytics) {
    const standard_properties = {
      'path': '#' + pageName,
      'url': window.location.href + '#' + pageName
    }

    const payload = window.analytics.page(
      { ...standard_properties, ...extra_properties },
      options
    )

    return dispatch => {
      dispatch(trackAnalyticsEvent({ analyticsTrackedEventsPayload: payload }))
    }
  }
}
